'use client';

import React from 'react'
import Link from 'next/link'
import { MdEmail, MdLocalPhone } from 'react-icons/md'
import {
    FaLocationDot,
    FaFacebook,
    FaInstagram,
    FaLinkedin,
    FaYoutube,
    FaXTwitter,
  } from "react-icons/fa6";

const socialLinks = [
    {
      href: "https://www.facebook.com/profile.php?id=61571785329732",
      icon: FaFacebook,
      text: "Facebook",
      color: "group-hover/nested:text-[#1877F2]",
    },
    {
      href: "https://x.com/centeratech",
      icon: FaXTwitter,
      text: "Twitter",
      color: "group-hover/nested:text-[#AAB8C2]",
    },
    {
      href: "https://www.instagram.com/centera.tech",
      icon: FaInstagram,
      text: "Instagram",
      customIcon: (
        <svg
          className="w-[18px] h-[18px] transition-all duration-500 ease-in-out"
          viewBox="0 0 169 169"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="instagramGradient" x1="1" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#833AB4" />
              <stop offset="50%" stopColor="#C13584" />
              <stop offset="100%" stopColor="#ffbf1f" />
            </linearGradient>
          </defs>
  
          <g className="transition-all duration-500 ease-in-out">
            <g className="fill-white transition-all duration-500 group-hover/nested:opacity-0">
              <path
                d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
          c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
          c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
          c17.455,0,31.656,14.201,31.656,31.655V122.407z"
              />
              <path
                d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
          C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
          c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
              />
              <path
                d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
          c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
          C135.661,29.421,132.821,28.251,129.921,28.251z"
              />
            </g>
  
            <g className="fill-[url(#instagramGradient)] transition-all duration-500 opacity-0 group-hover/nested:opacity-100">
              <path
                d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
          c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
          c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
          c17.455,0,31.656,14.201,31.656,31.655V122.407z"
              />
              <path
                d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
          C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
          c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
              />
              <path
                d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
          c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
          C135.661,29.421,132.821,28.251,129.921,28.251z"
              />
            </g>
          </g>
        </svg>
      ),
    },
    {
      href: "https://www.youtube.com/@CenteraTech",
      icon: FaYoutube,
      text: "YouTube",
      color: "group-hover/nested:text-[#FF0000]",
    },
    {
      href: "https://www.linkedin.com/in/centera-tech-72ba35347",
      icon: FaLinkedin,
      text: "LinkedIn",
      color: "group-hover/nested:text-[#0A66C2]",
    },
  ];

const ContactDetailsMap = () => {
  return (
    <section className="mt-10 max-w-7xl mx-auto px-4 md:px-14 lg:px-20">
    <div className="flex flex-col lg:flex-row justify-center gap-3">
      
      <div className="relative p-px rounded-2xl overflow-hidden group w-full lg:max-w-[409px]">
        
        <div className="absolute inset-0 rounded-2xl bg-[linear-gradient(155deg,var(--accent-light),#555_60%)] transition-transform duration-700 group-hover:rotate-180 blur-3xl scale-150"></div>

        <div className="relative bg-[--bg-transparent-1] rounded-2xl p-6 md:p-8 text-white w-full space-y-7 h-full">
          <h3 className="text-2xl font-semibold text-color-2">
            Contact Details
          </h3>

          <div className="flex items-center gap-3">
            <MdLocalPhone className="text-[--accent-light] text-xl" />
            <a
              href="tel:+919209155153"
              className="hover:text-color-2 transition-all"
            >
              +91 9209155153
            </a>
          </div>

          <div className="flex items-center gap-3">
            <MdEmail className="text-[--accent-light] text-xl" />
            <a
              href="mailto:support@centera.tech"
              className="hover:text-color-2 transition-all"
            >
              support@centera.tech
            </a>
          </div>

          <div className="flex items-start gap-3">
            <FaLocationDot className="text-[--accent-light] text-lg mt-1 flex-shrink-0" />
            <a
              href="https://www.google.com/maps?ll=16.707947,74.228303&z=15&t=h&hl=en&gl=IN&mapclient=embed&cid=1583718635517808008"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-color-2 transition-all"
            >
              Office no. 204, Eden Garden Commercial Complex, Kolhapur -
              416003, Maharashtra, India
            </a>
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-1 -ml-1">
            {socialLinks.map((link, index) => (
              <Link
                key={index}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Checkout ${link.text}`}
                className="text-white text-xl p-1.5 hover:text-gray-300 transition duration-300 group/nested"
              >
                {link.customIcon || (
                  <link.icon
                    className={`text-color-1 transition-all duration-300 
                       ${link.color || ""}
                     `}
                  />
                )}
                <span className="sr-only">{link.text}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="w-full min-w-[320px] md:min-w-[500px] h-full md:h-auto md:flex-1 rounded-[16px] overflow-hidden">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5224.5411715887885!2d74.2283033!3d16.707946599999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc101d6718f4ef9%3A0x15fa7fb546348d88!2sCentera%20Tech!5e1!3m2!1sen!2sin!4v1741607154671!5m2!1sen!2sin"
          className="w-full h-full min-h-[300px]"
          allowFullScreen
          loading="lazy"
          title="Google Map Location"
        ></iframe>
      </div>
    </div>
  </section>
  )
}

export default ContactDetailsMap